// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GvP-","badges":"styles_badges__3KASY"};